import { UserForm } from 'components/UserForm/UserForm';
import React from 'react';

export const AccountPage = () => {
  return (
    <>
      <UserForm />
    </>
  );
};
